import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const languages = [
    { code: 'it', label: 'IT' },
    { code: 'en', label: 'EN' },
    { code: 'de', label: 'DE' }
  ];

  return (
    <div
      data-testid="language-switcher"
      className="flex items-center gap-1 bg-white/50 backdrop-blur-sm rounded-md border border-[#2C5263]/10 p-1"
    >
      <Globe size={14} className="text-[#2C5263] ml-1" />
      {languages.map((lang) => (
        <button
          key={lang.code}
          data-testid={`lang-btn-${lang.code}`}
          onClick={() => setLanguage(lang.code)}
          className={`px-2 py-1 text-xs font-medium rounded transition-colors ${
            language === lang.code
              ? 'bg-[#2C5263] text-white'
              : 'text-[#666666] hover:text-[#2C5263]'
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
